export default "__VITE_ASSET__B0T9azk6__"